export class GenericManufacturerSimulation {
  id!: number;
  pharmacyRefId!: number;
  laboratoryId!: number;
  laboratoryName?: string;
  year?: number;
  month?: number;
  base?: string;
  type?: string;
  quantity?: number;
  grossAmountExclTax?: number;
  discountEuroExclTax?: number;
  discountPercent?: number;
  netAmountExclTax?: number;
  grossPercentileTarget?: number;
  totalCooperation?: number;
  ordreAssiette?: number;
  netTotalSimulation?: number;
  descriptionAssiette?: string;

  static fromBackend(data: any): GenericManufacturerSimulation {
    return {
      id: data.id,
      pharmacyRefId: data.idOfficineRef,
      laboratoryId: data.idLaboratoire,
      laboratoryName: data.nomLabo,
      month: data.month,
      year: data.annee,
      base: data.assiette,
      type: data.type,
      quantity: data.quantite,
      grossAmountExclTax: data.montantBrutHt,
      discountEuroExclTax: data.remiseEuroHt,
      discountPercent: data.remisePourcent,
      netAmountExclTax: data.montantNetHt,
      grossPercentileTarget: data.grossPercentileTarget,
      totalCooperation: data.montantCoop ?? 0,
      ordreAssiette: data.ordreAssiette,
      descriptionAssiette: data.descriptionAssiette,
    } as GenericManufacturerSimulation;
  }

  static fromBackendList(data: any[]): GenericManufacturerSimulation[] {
    return data.map(item => GenericManufacturerSimulation.fromBackend(item));
  }
}
